export default __webpack_public_path__ + "static/media/medium.f4c98232.png";